import classNames from "classnames";
import { FC } from "react";
import { useChangeDetector } from "../useOddChangeDetector/useChangeDetector";
import { ArrowIcon } from "../icons";

export type SpecialPriceProps = {
  value: number | string;
  sp: string;
};

const Price: FC<SpecialPriceProps> = ({ value, sp }) => {
  const { priceChangedType } = useChangeDetector(value || 0, `${sp}` || "");

  return (
    <div className="flex justify-center pl-2">
      <span
        className={classNames("flex items-center", {
          "bg-red-100": priceChangedType === "decrease",
          "bg-green-200": priceChangedType === "increase",
        })}>
        {value}
        <span
          className={classNames(` opacity-0`, {
            "arrow-down": priceChangedType === "decrease",

            "arrow-up": priceChangedType === "increase",
          })}>
          <ArrowIcon
            size={8}
            color={priceChangedType === "decrease" ? "#FF0000" : "#008000"}
          />
        </span>
      </span>
    </div>
  );
};

export default Price;
